// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"DeleteCategoryModal_modal-wrapper__nsvif"};